module.exports = __webpack_public_path__ + "img/dg-nav-below-nav-chevy.dd9cf34b.png";